// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-button-toggle {
   height: 40px;
   width: 40px;
   align-items: center;
}


.mat-button-toggle-standalone.mat-button-toggle-appearance-standard, .mat-button-toggle-group-appearance-standard {
   border: none;
   border-radius: 100%;
}

.text-color {
   display: flex;
}

.text-property {
   display: flex;
   margin-bottom: 10px;
}

.btn-select-color {
   width: 30px;
   height: 30px;
   padding: 5px;
   margin: 5px 30px 5px 5px;
}

.text-require{
   margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/properties/properties.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,WAAW;GACX,mBAAmB;AACtB;;;AAGA;GACG,YAAY;GACZ,mBAAmB;AACtB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,YAAY;GACZ,wBAAwB;AAC3B;;AAEA;GACG,mBAAmB;AACtB","sourcesContent":[".mat-button-toggle {\n   height: 40px;\n   width: 40px;\n   align-items: center;\n}\n\n\n.mat-button-toggle-standalone.mat-button-toggle-appearance-standard, .mat-button-toggle-group-appearance-standard {\n   border: none;\n   border-radius: 100%;\n}\n\n.text-color {\n   display: flex;\n}\n\n.text-property {\n   display: flex;\n   margin-bottom: 10px;\n}\n\n.btn-select-color {\n   width: 30px;\n   height: 30px;\n   padding: 5px;\n   margin: 5px 30px 5px 5px;\n}\n\n.text-require{\n   margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
